<template>
    <div class="am-add-notification">
        <div class="am-notification-title-bar">
            <span class="am-notification-title"><strong>New Notification</strong></span>
        </div>
        <form method="POST" :action="submitRoute" class="am-notification-form">
            <table class="am-notification-edit-results">
                <tr>
                    <td>
                        <strong>Type:</strong>
                    </td>
                    <td>
                        <select name="type" v-model="formData.type" @change="sendToDropdownSelect()">
                            <option value='0' >- Select Type -</option>
                            <option v-for="type in types" :value="type" :key="type">{{ type }}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>Send To:</strong>
                    </td>
                    <td v-show="!showDropDown" class="am-notification-message">
                      <span>{{this.sendToDefault}}</span>
                    </td>
                    <td class="am-width50percent">
                        <select name="sendTo" v-model="formData.sendTo" v-show="showDropDown">
                            <option value='0' >{{this.dropdownDefault}}</option>
                            <option v-for="(id, description) in typeArray" :value="id" :key="id">{{ description }}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>Title:</strong>
                    </td>
                    <td>
                        <input type="text" name="title" v-model="formData.title">
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>Message:</strong>
                    </td>
                    <td>
                        <textarea name="message" v-model="formData.message" rows="5"></textarea>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>Priority:</strong>
                    </td>
                    <td>
                        <select name="priority" v-model="formData.priority">
                            <option value='0' >- Select Priority -</option>
                            <option v-for="priority in priorities" :value="priority.value" :key="priority.value">{{ priority.description }}</option>
                        </select>
                    </td>
                </tr>
                <br>
            </table>
            <div class="am-blue-border"></div>
            <div class="am-align-button">
                <button type="button" @click="submitAction()" class="btn btn-primary btn-sm">Submit</button>&nbsp;
                <button type="button" @click="resetSelections()" class="btn btn-sm">Reset</button>&nbsp;
                <button type="button" @click="closeModal()" class="btn btn-sm">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>

import config from './../config/global.config'
import api from './../http'

export default {
  name: 'NotificationCreate',

  data: function () {
    return {
      submitRoute: config.apiUrl('/notifications'),
      types: [
        'Company Wide',
        'Employee',
        'Employee Group',
        'Office',
        'District',
        'Region',
        'Division',
        'Territory'
      ],
      priorities: [
        { description: 'Normal', value: 0 },
        { description: 'Info', value: 1 },
        { description: 'Warning', value: 2 },
        { description: 'Urgent', value: 3 }
      ],
      typeArray: [],
      sendToDefault: 'You Must Select A Notification Type',
      showDropDown: false,
      formData: {
        type: 0,
        sendTo: 0,
        title: '',
        message: '',
        priority: 0,
        fromUser: this.$store.state.auth.user.id,
        masterId: this.$store.state.auth.config.id
      }
    }
  },

  asyncComputed: {
    typeGroups: {
      get () {
        return api.makeRequest('/notifications/employee_groups/' + this.$store.state.auth.config.id).then(
          (data) => {
            return data.data.result
          }
        )
      },
      default: []
    }
  },

  methods: {

    resetSelections () {
      this.showDropDown = false
      this.sendToDefault = 'You Must Select A Notification Type'
      this.formData.type = 0
      this.formData.priority = 0
      this.formData.title = ''
      this.formData.message = ''
    },

    closeModal () {
      this.$store.dispatch('events/fireEvent', { name: 'notification-create-close', data: null })
      this.$modal.hide('notificationCreate')
    },

    sendToDropdownSelect () {
      this.showDropDown = true

      switch (this.formData.type) {
        case 'Employee':
          this.typeArray = this.typeGroups.employee
          this.dropdownDefault = '- Select Employee -'
          break
        case 'Employee Group':
          this.typeArray = this.typeGroups.employee_groups
          this.dropdownDefault = '- Select Employee Group -'
          break
        case 'Office':
          this.typeArray = this.typeGroups.offices
          this.dropdownDefault = '- Select Office -'
          break
        case 'Territory':
          this.typeArray = this.typeGroups.territories
          this.dropdownDefault = '- Select Territory -'
          break
        case 'Division':
          this.typeArray = this.typeGroups.divisions
          this.dropdownDefault = '- Select Division -'
          break
        case 'Region':
          this.typeArray = this.typeGroups.regions
          this.dropdownDefault = '- Select Region -'
          break
        case 'District':
          this.typeArray = this.typeGroups.districts
          this.dropdownDefault = '- Select District -'
          break
        case 'Company Wide':
          this.sendToDefault = ''
          this.showDropDown = false
          break
        default:
          this.sendToDefault = 'You Must Select A Type'
          this.showDropDown = false
      }
    },

    submitAction () {
      this.submit(this.formData)
    },

    submit (data) {
      let self = this
      this.$store.dispatch('events/fireEvent', { name: 'notification-create-close', data: null })
      api.postRequest('/notifications', data).then(function (response) {
        console.log(response)
        self.$emit('refreshList')
        self.$modal.hide('notificationCreate')
      })
    }
  }
}
</script>

<style scoped>
    .am-add-notification {
        display: block;
        border-radius: 4px;
        background-color: #fcfdfd;
        margin: 0;
        position: absolute;
        color: black;
    }
    .am-notification-title-bar {
        display: block;
        height: 35px;
        width: auto;
        border-radius: 1px;
        background: #2a95cc;
    }
    .am-notification-title {
        font-size: 14px;
        color: #FDFEFE;
        float: left;
        margin-top: 5px;
        margin-left: 10px;
    }
    .am-notification-form {
        font-size: 12px;
        padding: 9px;
        overflow: auto;
    }

    .am-notification-message span {
      margin: 4px 4px 4px 30px;
    }
    .am-notification-edit-results input, select, textarea{
        background-color: #ffffef;
        resize: none;
        margin: 4px 4px 4px 30px;
        width: 220px;
    }

    .am-blue-border {
        display: block;
        width: 100%;
        border-top: 1px solid #4297d7;
        margin-bottom: 8px;
    }
    .am-align-button {
        text-align: right;
        display: block;
        margin: auto;
    }
</style>
